import React from "react";
import { Wrapper, Image } from "./styled";
import Icon from "../../../../images/zoomIn.svg";

const ZoomInGlassIcon = (props) => {
  return (
    <Wrapper onClick={props.onClick}>
      <Image src={Icon} alt="icon" />
    </Wrapper>
  );
};

export default ZoomInGlassIcon;
